const GA_ID = process.env.REACT_APP_GA_ID;
let initialized = false;

export function initGA() {
  if (!GA_ID || initialized || typeof window === "undefined") return;
  initialized = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

// Generic event tracker — fires to GA4 (gtag) and/or PostHog if present. Safe no-op otherwise.
export function track(event, params = {}) {
  if (typeof window === "undefined") return;
  try {
    if (window.gtag) window.gtag("event", event, params);
    if (window.posthog && typeof window.posthog.capture === "function") window.posthog.capture(event, params);
  } catch (e) { /* ignore analytics errors */ }
}
